import * as React from 'react';
import { usePage } from '@inertiajs/react';
import { assetUrl } from '../../utils/assetUrl';
import { trackSignupClicked } from '../../utils/tracking';

interface Props {
  loginUrl: string;
  whatsappUrl: string;
}

export function SeresQueridosHero({ loginUrl, whatsappUrl }: Props) {
  const { cdnUrl } = usePage<{ cdnUrl: string }>().props;
  const heroImg = assetUrl(cdnUrl, '/img/seres-queridos-hero.png');

  return (
    <section className="sq-hero">
      <style>{`
        .sq-hero {
          position: relative;
          background: #1a1a1a url(${heroImg}) center center/cover no-repeat;
          padding: 100px 0 110px;
          min-height: 480px;
          display: flex;
          align-items: center;
        }
        .sq-hero::before {
          content: '';
          position: absolute;
          inset: 0;
          background: rgba(0, 0, 0, 0.62);
        }
        .sq-hero-inner {
          position: relative;
          z-index: 1;
          max-width: 800px;
          margin: 0 auto;
          padding: 0 24px;
          text-align: center;
        }
        .sq-hero h1 {
          font-size: 38px;
          font-weight: 800;
          color: #fff;
          margin: 0 0 16px;
          line-height: 1.2;
        }
        .sq-hero .sq-hero-sub {
          font-size: 20px;
          color: rgba(255, 255, 255, 0.9);
          margin: 0 0 12px;
          font-weight: 500;
        }
        .sq-hero .sq-hero-desc {
          font-size: 17px;
          color: rgba(255, 255, 255, 0.75);
          margin: 0 0 36px;
        }
        .sq-hero-ctas {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }
        .sq-btn-primary,
        .sq-btn-secondary {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 14px 28px;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 700;
          text-decoration: none;
          transition: opacity 0.15s ease;
        }
        .sq-btn-primary {
          background: #1EAA25;
          color: #fff;
        }
        .sq-btn-secondary {
          background: rgba(255, 255, 255, 0.12);
          color: #fff;
          border: 1px solid rgba(255, 255, 255, 0.5);
        }
        .sq-btn-primary:hover,
        .sq-btn-secondary:hover {
          opacity: 0.9;
          color: #fff;
          text-decoration: none;
        }
        @media (max-width: 768px) {
          .sq-hero { padding: 72px 0 80px; min-height: 420px; }
          .sq-hero h1 { font-size: 29px; }
          .sq-hero .sq-hero-sub { font-size: 18px; }
        }
        @media (max-width: 640px) {
          .sq-hero-ctas { flex-direction: column; }
          .sq-btn-primary, .sq-btn-secondary { justify-content: center; }
        }
      `}</style>

      <div className="sq-hero-inner">
        <h1>Comprá para que a tus seres queridos no les falte nada</h1>
        <p className="sq-hero-sub">
          Pedís vos desde el celular. Llevamos frutas y verduras frescas hasta su puerta,
          el día y en la franja horaria que elijas.
        </p>
        <p className="sq-hero-desc">
          Sin que tengan que salir, hacer cola ni cargar bolsas.
        </p>
        <div className="sq-hero-ctas">
          <a
            href={loginUrl}
            className="sq-btn-primary"
            onClick={() => trackSignupClicked('seres-queridos', 'hero')}
          >
            <i className="fa fa-user-plus" /> Crear una cuenta
          </a>
          <a href={whatsappUrl} className="sq-btn-secondary" target="_blank" rel="noopener noreferrer">
            <i className="fa fa-whatsapp" /> Consultar por WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
